module.exports = __webpack_public_path__ + "static/img/wxd.04198388.png";